import React from 'react';
import { Link } from 'react-router-dom';
import emptyAssortmentView from './images/ManageAssortmentMainFilters.png';
import assortmentSelection from './images/AssortmentSelection.png';
import assortmentFiltering from './images/AssortmentFiltering.png';

export default function () {
    return (
        <div className="assortment">
            <h2>Managing Assortment</h2>
            <h3>Overview</h3>
            <p>
                Within the assortment we want to make sure we can do all we can to promote accuracy and speed. When dealing
                with the assortment we have multiple features that will help give you comfort in your choices such as
                material filtering and real time option count feedback.
            </p>
            <p>
                Within the manage assortment view you must select{' '}
                <strong>at least one partner, category and division</strong> to have your assortment populate. From there you
                can start editing store/material combinations. If you have permission for only one partner, category or
                division, that one will automatically be selected for you.
                <img src={emptyAssortmentView} alt="No main filters selected" />
            </p>
            <h3>Selecting Your Assortment</h3>
            <p>
                When selecting your assortment you will see a list of materials, their detailed information in columns, as
                well as the stores that were within the option counts file tied to the partner you selected.
            </p>
            <p>
                Within the store columns you will notice blank and checked boxes that are correlated to a specific material.
                If the box is <strong>checked</strong> that given material has been chosen to exist within the Buyplan. If
                the box is <strong>not checked</strong> then that material has not been selected for the given store to be
                purchased. Below you can find a visualization of the selection:
                <img src={assortmentSelection} alt="Assortment selection" />
            </p>
            <h3>Tracking Manual Adjustments</h3>
            <p>
                Tracking manual changes can be difficult when dealing with a lot of stores and materials. To help with that
                we have given each material/store that has been manually changed within the assortment a color:
            </p>
            <ol>
                <li>Blue - To highlight changes made by Nike planners</li>
                <li>
                    No color - To indicate that the material/store combination was not changed and aligns with the value in
                    merchandise file
                </li>
            </ol>
            <p>
                If you look at the above photo you can see how it appears when you manually assort a material that was not
                originally going to a store as well as a material that was originally assorted but has been removed manually.
            </p>
            <h3>Filtering Your Assortment</h3>
            <p>
                For a given Partner/Category/Division combination there are still many materials that could be involved
                within an assortment. To help solve this issue we have built in a filters that can be found near the column
                name.
                <img src={assortmentFiltering} alt="Assortment filtering" />
            </p>
            <h3>Hide/Show Columns and Stores Ordering</h3>
            <p>
                Please see the <Link to="/buyplan/documentation/user-settings">User Settings section</Link> for more
                information about hiding/showing columns and ordering stores within the Assortment view.
            </p>
        </div>
    );
}
